import { recommended as commonRecommended } from '../common/before.js';

export const recommended = [...commonRecommended];
